import React from "react";
import { FaBed, FaBuilding, FaMapMarkerAlt } from "react-icons/fa"; // Property icons
import { formatCurrencyUtil, getImageUrl } from "../../Utils/localStorageUtils";
import useCustomNavigate from "../../hooks/useCustomNavigate";

const ProjectResultCardComponent = ({ projectData }) => {

    const {goTo} = useCustomNavigate()
    const {
        _id,
        basicDetails,
        locationDetails,
        pricingAndOthers,
        media,
        projectDetails,
        amenities,
        createdAt,
        floorPricingDetails,
    } = projectData;

    return (
        <div className="flex border rounded-lg shadow-md overflow-hidden bg-white hover:shadow-lg transition-shadow duration-300 ">
            {/* Left Image Section */}
            <div className="w-[30%] px-3 py-3 border cursor-pointer"
            onClick={()=>{goTo(`/project/${_id}`)}}
            >
                <div className="relative h-[150px]">
                    <img
                        src={getImageUrl(media?.projectPictures?.[0]) || "https://via.placeholder.com/300"}
                        alt="Property"
                        onError={(e)=>e.target.src="https://cdn.staticmb.com/property/microsite/mbimages/01155714/projectspotlight-img.jpg"}
                        className="rounded-md w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 bg-black text-white text-[10px] rounded w-full py-1 bg-opacity-50 px-2">
                        Posted: {createdAt ? new Date(createdAt).toLocaleDateString() : "Jan 20, '25"}
                    </div>
                </div>
            </div>

            {/* Middle Details Section */}
            <div className="w-[50%] px-4 py-3">
                <h2 
                className="text-md font-semibold text-[#303030] cursor-pointer"
                onClick={()=>{goTo(`/project/${_id}`)}}
                >
                    {basicDetails?.bhkType} in {locationDetails?.searchLocation}
                </h2>
                <p className="text-xs text-[#606060]">{basicDetails?.projectName}</p>

                {locationDetails?.apartmentSociety && (
                    <p className="text-xs underline text-[#606060]">{locationDetails.apartmentSociety}</p>
                )}

                <div className="mt-4 text-gray-600 text-sm">
                    <p><strong>Location:</strong> {locationDetails?.searchLocation}</p>
                    <p className="mt-2"><strong>Status:</strong> {projectDetails?.status}</p>
                    <p className="mt-2"><strong>Launch Date:</strong> {new Date(projectDetails?.launchDate).toLocaleDateString()}</p>
                </div>

                {/* Amenities */}
                <div className="mt-4">
                    <h3 className="text-lg font-semibold text-[#303030]">Amenities</h3>
                    <ul className="list-none mt-2">
                        {amenities?.swimmingPool && <li className="text-xs">Swimming Pool</li>}
                        {amenities?.clubhouse && <li className="text-xs">Clubhouse</li>}
                        {amenities?.gym && <li className="text-xs">Gym</li>}
                        {amenities?.parking && <li className="text-xs">Parking</li>}
                        {amenities?.security && <li className="text-xs">Security</li>}
                    </ul>
                </div>
            </div>

            {/* Right Pricing and CTA Section */}
            <div className="w-[20%] text-center bg-[#f5f5f5] flex flex-col justify-between px-5 py-4">
                <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                        {floorPricingDetails[0]?.floorPriceMax ? formatCurrencyUtil(floorPricingDetails[0]?.floorPriceMax) : "40 lac"}
                
                    </h3>
                    <p className="text-sm text-gray-600 mt-2">
                        {formatCurrencyUtil(projectDetails?.pricePerSqft)} per SqFt
                    </p>
                </div>

                {/* Floor Pricing */}
                {floorPricingDetails?.[0] && (
                    <div className="mt-3">
                        <h3 className="text-sm font-semibold text-[#303030]">Floor Pricing</h3>
                        <p className="text-xs">Price Range: {formatCurrencyUtil(floorPricingDetails[0]?.floorPriceMin)} - {formatCurrencyUtil(floorPricingDetails[0]?.floorPriceMax)}</p>
                        <p className="text-xs">Area Range: {floorPricingDetails[0]?.superAreaMin} - {floorPricingDetails[0]?.superAreaMax} {floorPricingDetails[0]?.superAreaUnit}</p>
                    </div>
                )}

                <div className="space-y-3 mt-4">
                    <button className="w-full bg-red-600 text-white text-sm py-1 rounded-full shadow hover:bg-red-700">
                        Contact Agent
                    </button>
                    <button className="w-full border border-red-600 text-red-600 text-sm py-1 rounded-full shadow hover:bg-red-50">
                        Enquire Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectResultCardComponent;
